export { multioksjon };

let calcRoute, getAuction, getAuctionKey, initMap, clearDestination, setDestination, refreshAuctions, clearTimers, calculateAndDisplayRoute, refreshKulu, refreshMarker, activateAuction, deactivateAuction, resetRouteInfo,
    setLatvia, isLatvia, isCountryAllowed, setFerry, setTotal, setTotalLand, setPath, updateSlogan, checkKogus, checkKlausels, changeKlausel, changeDestination, showHideAuctions, parseResponse;

const multioksjon = () => {
    if (MODULE_NAME === "multioksjon") {

        getAuction = function(id) {
            for (i = 0; i < auctions.length; i++) {
                if (auctions[i].id == id) {
                    return auctions[i];
                }
            }
            return false;
        }
    
        getAuctionKey = function(id) {
            for (i = 0; i < auctions.length; i++) {
                if (auctions[i].id == id) {
                    return i;
                }
            }
            return false;
        }
    
        initMap = function() {
            var a, i, t;
            console.info("initMap");
    
            if (document.getElementById("map")) {
                var mapOptions = {
                    zoom: 7,
                    minZoom: 7,
                    center: center
                }
                map = new google.maps.Map(document.getElementById("map"), mapOptions);
    
                if (!group_id) {
                    map.addListener("click", function (e) {
                        if (tarnekoht) {
                            console.info("tarnekoht", tarnekoht, "on juba valitud");
                        } else {
                            destination = e.latLng;
                            console.log(e.latLng, map);
                            map.panTo(e.latLng);
    
                            $("#latitude").val(e.latLng.lat);
                            $("#longitude").val(e.latLng.lng);
    
                            if (marker) {
                                marker.setMap(null);
                            }
                            marker = new google.maps.Marker({
                                map: map,
                                draggable: true,
                                animation: google.maps.Animation.DROP,
                                title: "My location",
                                position: e.latLng
                            });
                            marker.addListener("dragend", function (e) {
                                destination = e.latLng;
                                console.log(e.latLng, map);
    
                                $("#latitude").val(e.latLng.lat);
                                $("#longitude").val(e.latLng.lng);
    
                                refreshAuctions();
                            });
                            refreshAuctions();
                        }
                    });
                }
    
                //directionsDisplay.setMap(map);
    
                for (i = 0; i < auctions.length; i++) {
                    a = auctions[i];
    
                    console.log(a);
    
                    //if (!group_id || a.active) {
                    auctions[i].directionsDisplay = new google.maps.DirectionsRenderer({
                        preserveViewport: true,
                        suppressMarkers: true
                    });
                    //a.directionsDisplay.setMap(map);
    
                    refreshMarker(a.id);
                    //}
                }
    
                var latitude = $("#latitude").val();
                var longitude = $("#longitude").val();
                if (latitude != "" && longitude != "") {
                    window.setTimeout(function () {
                        setDestination(latitude, longitude);
                    }, 250);
                }
            }
        }
    
        clearDestination = function() {
            if (marker) {
                marker.setMap(null);
                marker = null;
            }
            destination = null;
            refreshAuctions();
        }
    
        setDestination = function(latitude, longitude) {
            destination = new google.maps.LatLng(latitude, longitude);
            map.panTo(destination);
    
            if (marker) {
                marker.setMap(null);
            }
    
            marker = new google.maps.Marker({
                map: map,
                draggable: (group_id > 0 || tarnekoht > 0 ? false : true),
                animation: google.maps.Animation.DROP,
                title: "My location",
                position: destination
            });
            if (!group_id && !tarnekoht) {
                marker.addListener("dragend", function (e) {
                    destination = e.latLng;
                    console.log(e.latLng, map);
    
                    $("#latitude").val(e.latLng.lat);
                    $("#longitude").val(e.latLng.lng);
    
                    refreshAuctions();
                });
            }
            refreshAuctions();
            //if (group_id) {
    
            //}
        }
    
        refreshAuctions = function() {
            var i, a, t, p = 0;
    
            clearTimers();
            for (i = 0; i < auctions.length; i++) {
                a = auctions[i];
                if (destination) {
                    if (a.active) {
                        t = 750 * (0.1 + p);
                        auctions[i].timer = window.setTimeout(function (a, i, destination) {
                            auctions[i].timer = null;
                            //var directionsDisplay = new google.maps.DirectionsRenderer();
                            //directionsDisplay.setMap(map);
                            console.log("Draw", i, a.name, a.latLng);
                            //if (i < 200) {
                            //calculateAndDisplayRoute(directionsService, a.directionsDisplay, start, a.latLng);
                            a.directionsDisplay.setMap(map);
                            calculateAndDisplayRoute(directionsService, a, destination, i);
                            //}
                        }, t, a, i, destination);
                        p++;
                    }
                } else {
                    setTotal(a.id, 0);
                    setTotalLand(a.id, 0);
                    setPath(a.id, "");
    
                    refreshKulu(a.id);
                }
            }
        }
    
        clearTimers = function() {
            $("#info").html("");
    
            for (i = 0; i < auctions.length; i++) {
                if (auctions[i].timer) {
                    window.clearTimeout(auctions[i].timer);
                }
                auctions[i].timer = null;
    
                if (auctions[i].directionsDisplay) {
                    auctions[i].directionsDisplay.setDirections({
                        routes: []
                    });
                    auctions[i].directionsDisplay.setMap(null);
                } else {
                    console.log("clearTimers()", "directionsDisplay is NULL")
                }
            }
        }
    
        //function calculateAndDisplayRoute(directionsService, directionsDisplay, start, end) {
        calculateAndDisplayRoute = function(directionsService, a, end, index) {
            MO.startSpin();
            directionsService.route({
                origin: a.latLng,
                destination: end,
                travelMode: google.maps.TravelMode.DRIVING
            }, function (response, status) {
                MO.stopSpin();
                console.group("calculateAndDisplayRoute");
                console.log(response);
                console.log(status);
                if (status === google.maps.DirectionsStatus.OK) {
                    if (false) {
                        auctions[index].marker.setMap(null);
                    }
    
                    resetRouteInfo(a.id);
    
                    var txt = response.routes[0].summary;
                    var km = response.routes[0].legs[0].distance.text;
    
                    log("txt", txt, "km", km);
                    //$("<tr><td>" + index + "</td><td>" + a.name + "</td><td>" + km + "</td><td>" + txt + "</td></tr>").prependTo("#info");
    
                    //console.log(response.routes[0].legs[0].distance, response.routes[0].summary);
                    a.directionsDisplay.setDirections(response);
    
                    var total = 0;
                    var total_land = 0;
                    var distval = 0;
                    var steps, step, path;
                    for (var i = 0; i < response.routes[0].legs.length; i++) {
                        steps = response.routes[0].legs[i].steps;
                        distval = response.routes[0].legs[i].distance.value;
                        total += distval;
                        for (var s = 0; s < steps.length; s++) {
                            step = steps[s];
    
                            n1 = step.instructions.indexOf("Entering Latvia");
                            n2 = step.instructions.indexOf("Sisenemine riiki: Läti");
                            //console.log(s, step.instructions, n);
                            if (n1 > 1 || n2 > 1) {
                                setLatvia(a.id, 1);
                                log("is_latvia", 1);
                            }
                            if (step.maneuver != "ferry") {
                                total_land += step.distance.value;
                            } else {
                                log("Ferry", (step.distance.value / 1000), "km");
                                setFerry(a.id, 1);
                            }
                        }
                    }
                    total = Math.ceil(total / 1000);
                    total_land = Math.ceil(total_land / 1000);
                    path = response.routes[0].overview_polyline;
    
                    log("total", total, "km");
                    log("total_land", total_land, "km");
                    log("path", path);
                    $("#kaugus-" + a.id).html(total_land + " km");
                    $("#kaugus-wrapper-" + a.id).show();
    
                    if (isLatvia(a.id) && !isCountryAllowed(a.id, "lv")) {
                        MO.warning("Lätti tarnimine ei ole antud oksjonil lubatud!");
                        deactivateAuction(a.id, 1);
    
                        var $auction = $(".auction-id-" + a.id);
                        var $curtain = $auction.find(".curtain");
                        var $chk = $auction.find(".auction-check");
    
                        $chk.prop("checked", false);
                        $curtain.show();
                    } else {
                        setTotal(a.id, total);
                        setTotalLand(a.id, total_land);
                        setPath(a.id, path);
    
                        refreshKulu(a.id);
                    }
                } else {
                    console.error("Directions request failed due to " + status);
                }
                console.groupEnd();
            });
        }
    
        //					$ret->fob = $fob_price;
        //					$ret->dat = $dat_price;
        //					$ret->dap = $dap_price;
        //					$ret->road = $teemaks_kulud;
        //					$ret->total = $fob_price + $dat_price + $dap_price + $teemaks_kulud;
    
        refreshKulu = function(id) {
            var i, a, kogus;
            if ((i = getAuctionKey(id)) !== false) {
                a = auctions[i];
    
                kogus = $(".auction-id-" + id).find(".kogus").val();
                if (kogus != "") {
                    kogus = parseInt(kogus);
                } else {
                    kogus = 0;
                }
                var extra = "&auction=" + id + "&tarneklausel=" + tarneklausel + "&tarnekoht=" + tarnekoht + "&kaugus=" + auctions[i].total + "&kaugus_land=" + auctions[i].total_land + "&is_latvia=" + auctions[i].is_latvia + "&is_ferry=" + auctions[i].ferry + "&kogus=" + kogus;
    
                $.getJSON(auction_link + extra, function (data) {
                    var i, a, id, pakkumine, total;
                    console.log(data);
                    if (data.auction) {
                        id = data.auction;
                        if ((i = getAuctionKey(data.auction)) !== false) {
                            auctions[i].fee_total = parseFloat(data.total);
    
                            var $a = $(".auction-id-" + id);
                            $a.find(".kulud_kokku").html(data.total);
    
                            pakkumine = $a.find(".pakkumine").val();
                            if (isNaN(pakkumine)) {
                                pakkumine = 0;
                            } else {
                                pakkumine = parseFloat(pakkumine.replace(/,/g, "."));
                            }
                            total = auctions[i].fee_total + pakkumine;
                            $a.find(".pakkumine_kokku").html(total.toFixed(2));
    
                            $a.find(".price_FOB").val(data.fob);
                            $a.find(".price_DAT").val(data.dat);
                            $a.find(".price_DAP").val(data.dap);
                            $a.find(".price_muu").val(0);
                            $a.find(".price_teemaks").val(data.road);
                            $a.find(".price_total").val(data.total);
                        }
                    }
                });
            }
        }
    
        refreshMarker = function(id) {
            var i, a;
            if ((i = getAuctionKey(id)) !== false) {
                a = auctions[i];
    
                if (a.marker) {
                    auctions[i].marker.setMap(null);
                    auctions[i].marker = null;
                }
    
                auctions[i].marker = new google.maps.Marker({
                    map: map,
                    draggable: false,
                    title: a.name,
                    position: a.latLng,
                    icon: (a.active ? icon_log_1 : icon_log_0)
                });
            }
        }
    
        activateAuction = function(id) {
            var i, a;
    
            if ((i = getAuctionKey(id)) !== false) {
                //var $auction = $(".auction-id-" + id);
                //var $curtain = $auction.find(".curtain");
                //$curtain.hide();
    
                a = auctions[i];
    
                auctions[i].active = 1;
    
                auctions[i].timer = null;
                console.log("Draw", i, a.name, a.latLng);
                auctions[i].directionsDisplay.setMap(map);
                calculateAndDisplayRoute(directionsService, a, destination, i);
    
                refreshMarker(id);
            }
        }
    
        deactivateAuction = function(id, refresh) {
            var i, a;
            if ((i = getAuctionKey(id)) !== false) {
                //var $auction = $(".auction-id-" + id);
                //var $curtain = $auction.find(".curtain");
                //$curtain.show();
    
                a = auctions[i];
    
                auctions[i].active = 0;
    
                if (auctions[i].timer) {
                    window.clearTimeout(auctions[i].timer);
                }
                auctions[i].timer = null;
                if (auctions[i].directionsDisplay) {
                    auctions[i].directionsDisplay.setDirections({
                        routes: []
                    });
                    auctions[i].directionsDisplay.setMap(null);
                }
    
                $("#kaugus-" + a.id).html("");
                $("#kaugus-wrapper-" + a.id).hide();
    
                if (refresh) {
                    refreshMarker(id);
                }
            }
        }
    
        resetRouteInfo = function(id) {
            var i;
            if ((i = getAuctionKey(id)) !== false) {
                auctions[i].is_latvia = 0;
                auctions[i].ferry = 0;
                auctions[i].total = 0;
                auctions[i].total_land = 0;
                auctions[i].path = "";
    
                $(".auction-id-" + id).find(".ylevedu").val(0);
                $(".auction-id-" + id).find(".kaugus").val(0);
                $(".auction-id-" + id).find(".kaugus_land").val(0);
                $(".auction-id-" + id).find(".is_latvia").val(0);
                $(".auction-id-" + id).find(".overview_path").val("");
            }
        }
    
        setLatvia = function(id, state) {
            var i;
            if ((i = getAuctionKey(id)) !== false) {
                auctions[i].is_latvia = state;
    
                $(".auction-id-" + id).find(".is_latvia").val(state);
            }
        }
    
        isLatvia = function(id) {
            var i;
            if ((i = getAuctionKey(id)) !== false) {
                return auctions[i].is_latvia;
            }
            return false;
        }
    
        isCountryAllowed = function(id, country) {
            var i;
            if ((i = getAuctionKey(id)) !== false) {
                for (j = 0; j < auctions[i].countries.length; j++) {
                    if (auctions[i].countries[j] == country) {
                        return true;
                    }
                }
            }
            return false;
        }
    
        setFerry = function(id, state) {
            var i;
            if ((i = getAuctionKey(id)) !== false) {
                auctions[i].ferry = state;
    
                $(".auction-id-" + id).find(".ylevedu").val(state);
            }
        }
    
        setTotal = function setTotal(id, val) {
            var i;
            if ((i = getAuctionKey(id)) !== false) {
                auctions[i].total = val;
    
                $(".auction-id-" + id).find(".kaugus").val(val);
            }
        }
    
        setTotalLand = function(id, val) {
            var i;
            if ((i = getAuctionKey(id)) !== false) {
                auctions[i].total_land = val;
    
                $(".auction-id-" + id).find(".kaugus_land").val(val);
            }
        }
    
        setPath = function(id, val) {
            var i;
            if ((i = getAuctionKey(id)) !== false) {
                auctions[i].path = val;
    
                $(".auction-id-" + id).find(".overview_path").val(val);
            }
        }
    
        updateSlogan = function() {
            var $s = $("#slogan"),
                text = $s.data("text"),
                n = $(".auction-check:checked").length;
            if (n > 0) {
                n = n + "-le";
            }
            $s.html(text.replace(/%s/g, n));
        }
    
        checkKogus = function() {
            var err = 0;
            $(".auction-check:checked").each(function () {
                var id = $(this).val();
                var $o = $(".auction-id-" + id);
                var $k = $o.find(".kogus");
                var kogus = $k.val();
                var min = $k.data("MinKogus");
                console.log($o, $k);
    
                if (kogus == "" || kogus == 0) {
                    MO.error(enterAmountTxt);
                    err++;
                } else if (kogus < min) {
                    MO.error(amountErrorTxt);
                    err++;
                }
            });
            return err;
        }
    
        checkKlausels = function(id) {
            var $o = $(".auction-id-" + id);
        }
    
        directionsService = new google.maps.DirectionsService();
        center = new google.maps.LatLng(58.68036419607682, 25.3564453125);
    
    
        $(document).on("click", ".json", function () {
            //if (confirm("Soovite saata oksjonil osalemise sooviavalduse?")) {
            var href = $(this).attr("href");
    
            $.getJSON(href, function (data) {
                console.log(data);
                if (data.ok) {
                    var $block = $(".auction-id-" + data.osalen);
                    var $offer = $block.find(".offer-wrapper");
                    console.log($block);
                    console.log($offer);
                    $offer.find("p").html(data.text);
                }
            });
            //}
            return false;
        });
    
        $(document).on("click", ".auction-check", function () {
            var chk = $(this).get(0).checked;
            var id = $(this).val();
            var $auction = $(".auction-id-" + id);
            var $curtain = $auction.find(".curtain");
            console.log("auction", chk, id, $auction, $curtain);
    
            if (chk) {
                if (!destination) {
                    $(this).prop("checked", false);
                    $.noty.closeAll();
                    MO.warning("Pakkumise tegemiseks määrake esmalt soovitud tarnekoht");
                    return false;
                }
    
                checkKlausels(id);
    
                $curtain.hide();
                activateAuction(id);
            } else {
                $curtain.show();
                deactivateAuction(id, 1);
            }
            updateSlogan();
        });
    
        $(document).on("keyup", ".pakkumine", function () {
            var id = $(this).data("id");
            var i, $val, pakkumine, total;
            console.log(id);
            if ((i = getAuctionKey(id)) !== false) {
                $val = $(".auction-id-" + id).find(".pakkumine");
                pakkumine = $val.val();
    
                pakkumine = pakkumine.toString().replace(/,/g, ".");
                pakkumine = pakkumine.replace(/[^\d\.]/g, "");
    
                if (isNaN(pakkumine)) {
                    //pakkumine = 0;
                } else {
                    //pakkumine = parseFloat(pakkumine.replace(/,/g, "."));
                    //pakkumine = parseFloat(pakkumine);
                }
                $val.val(pakkumine);
                total = auctions[i].fee_total + pakkumine;
                $(".auction-id-" + id).find(".pakkumine_kokku").html(total.toFixed(2));
            }
        });
    
        $(".auction-check").each(function () {
            var chk = $(this).get(0).checked;
            var id = $(this).val();
            var $auction = $(".auction-id-" + id);
            var $curtain = $auction.find(".curtain");
            if (chk) {
                $curtain.hide();
    
                if ((i = getAuctionKey(id)) !== false) {
                    a = auctions[i];
                    auctions[i].active = 1;
                }
            } else {
                $curtain.show();
            }
        });
        $(document).on("click", ".submit-one-offer", function () {
            $.noty.closeAll();
    
            var id = $(this).data("id");
            var $form = $("#auctions");
    
            $("#one_offer").val(id);
            $.post($form.attr("action"), $form.serialize(), function (data) {
                log(data);
                parseResponse(data);
            }, "json");
    
            return false;
        });
    
        $(document).on("click", ".submit-multi-offer", function () {
            $.noty.closeAll();
    
            if (!$(".auction-check:checked").length) {
                MO.error(errorTxt1);
            } else if (checkKogus() > 0) {
                // errors
            } else if (!$("#kulunous").get(0).checked) {
                MO.error(errorTxt2);
            } else if (!$("#nousolek").get(0).checked) {
                MO.error(errorTxt3);
            } else {
                var $form = $("#auctions");
    
                $.post($form.attr("action"), $form.serialize(), function (data) {
                    log(data);
                    if (data.koond_id) {
                        $("#koond_id").val(data.koond_id);
                    }
                    parseResponse(data);
                    if (data.auctions) {
                        $.each(data.auctions, function (key, value) {
                            parseResponse(value);
                        });
                    }
                }, "json");
            }
            return false;
        });
    
        $(document).on("change", "#tarneklausel", function () {
            var val = $(this).val();
            console.log(this, val);
    
            changeKlausel(val);
        });
    
        $(document).on("change", "#select-multi", function () {
            var val = $(this).val();
            console.log(this, val);
            document.location = selectMultiLinkIt + val;
        });
    
        $(document).on("change", ".klausel-grupp", function () {
            var val = $(this).val();
            console.log(this, val);
    
            changeDestination(val);
        });
    
        $(".clear").click(function () {
            clearTimers();
            return false;
        });
    
        initMap();
    
        if (!group_id) {
            window.setTimeout(function () {
                changeKlausel($("#tarneklausel").val());
            }, 500);
        }
    
        $(document).on("click", ".json-mass", function () {
            if (confirm("Soovite saata oksjonitel osalemise sooviavaldused?")) {
                $("#saada-wrapper").hide();
                $(".soovin").each(function () {
                    var chk = $(this).get(0).checked;
                    if (chk) {
                        $(this).parent().find("a").trigger("click");
                    }
                });
            }
            return false;
        });
    
        $(document).on("click", ".soovin", function () {
            var chk = $(this).get(0).checked;
            if (chk) {
                $("#saada-wrapper").show();
            }
        });
    
        $(document).on("change", "#puidusortiment", function () {
            var val = $(this).val();
            console.log(this, val);
    
            puidusortiment = parseInt(val);
            if (isNaN(puidusortiment)) {
                puidusortiment = 0;
            }
    
            document.location = puidusortimentLinkIt + puidusortiment;
            //showHideAuctions();
        });
    
        changeKlausel = function(klausel) {
            tarneklausel = klausel;
            console.log("changeKlausel", tarneklausel);
    
            $(".klausel-wrapper").hide();
            $("#tarnekoht-" + tarneklausel).show();
    
            showHideAuctions();
    
            changeDestination($("#tarnekoht-" + tarneklausel).find("select").val());
        }
    
        showHideAuctions = function() {
            var active_id = $("#tarnekoht-" + tarneklausel).find("select").val();
            $(".extended-auction-block").each(function () {
                console.log(this);
                var id = $(this).data("id");
                var fob = "" + $(this).data("fob");
                var psid = "" + $(this).data("puidusortiment");
                var k = $(this).data("tarneklausel");
                var n = k.indexOf(tarneklausel);
    
                console.log("fob", typeof fob, fob);
    
                if (tarneklausel == "FOB") {
                    var m = fob.indexOf(active_id);
                    console.log(tarneklausel, active_id, fob, m);
                    if (m == -1) {
                        n = -1;
                    }
                }
    
                if (puidusortiment == 0 || puidusortiment == psid) {
                    // OK
                } else {
                    n = -1;
                }
    
                if (n == -1) {
                    if (is_multi) {
                        deactivateAuction(id, 0);
                        $(this).hide();
                        $(this).find(".auction-check").prop("checked", false);
                    }
                } else {
                    $(this).show();
                }
            });
        }
    
        changeDestination = function(val) {
            val = parseInt(val);
            var $obj = $("#incoterm_latlng_" + val);
            console.log("changeDestination", val, $obj);
            if ($obj.length) {
                tarnekoht = val;
    
                var latlng = $obj.val();
                var pieces = latlng.split(",");
                $("#latitude").val(pieces[0]);
                $("#longitude").val(pieces[1]);
    
                if (pieces[0] != "" && pieces[1] != "") {
                    setDestination(pieces[0], pieces[1]);
                }
            } else {
                tarnekoht = 0;
    
                $("#latitude").val("");
                $("#longitude").val("");
                clearDestination();
            }
        }
    
        parseResponse = function(data) {
            var n;
            if (data.confirm) {
                n = MO.confirm(data.confirm);
            } else if (data.success) {
                //log("hide #set-route");
                //$("#set-route").hide();
                n = MO.notify(data.success, "success");
                // Bid was accepted, refresh auction data
                log("Bid was accepted, refresh auction data");
                //MO.refresh();
            } else if (data.error) {
                n = MO.notify(data.error, "error");
            } else if (data.warning) {
                n = MO.notify(data.warning, "warning");
            } else if (data.information) {
                n = MO.notify(data.information, "information");
            }
            log(n)
        }
    
        calcRoute = function() {
            console.log("calcRoute #2");
    
            var start = document.getElementById("start").value;
            var end = document.getElementById("end").value;
            var request = {
                origin: start,
                destination: end,
                travelMode: google.maps.TravelMode.DRIVING
            };
            directionsService.route(request, function (result, status) {
                if (status == google.maps.DirectionsStatus.OK) {
                    directionsDisplay.setDirections(result);
                }
            });
        }
    }
}